import {FileInputComponent, FormInputComponentDecorator} from '.';

export function FormInputComponent({input, initialized, error, controller, uniqueName, label, inputType, initialValue, fieldObject}) {

    function isBlank(variable) {
        return(variable == null  || typeof(variable) == 'undefined' || variable === '');
    }

    if( (!isBlank(initialValue)) && isBlank(input[uniqueName]) && !initialized[uniqueName] ) {
        input[uniqueName] = initialValue;
        initialized[uniqueName] = true;
    }

    const opts = {};
    if(fieldObject.helpText) opts['aria-describedby'] = uniqueName + 'Help';
    if(fieldObject.autoComplete) opts['autoComplete'] = fieldObject.autoComplete;

    if( inputType === 'hidden' )
        return <input
            type={inputType}
            name={uniqueName}
            value={input[uniqueName]}
        />;
    else if ( inputType === 'checkbox' ) {
        return (
            <div className="form-check mb-3">
                <FormInputComponentDecorator error={error} fieldObject={fieldObject}>
                    <input
                        type={inputType}
                        className="form-check-input"
                        name={uniqueName}
                        value={input[uniqueName]}
                        checked={input[uniqueName] ? true : false}
                        onChange={controller.handleChange}
                        onBlur={controller.validateInput} {...opts}
                    />
                    <label className="form-check-label" htmlFor="{uniqueName}">{label}</label>
                </FormInputComponentDecorator>
            </div>
        )
    }
    else return (
        <div className={'mb-3' + (error[uniqueName] ? ' has-error' : '')}>
            <label htmlFor={uniqueName}>{label}</label>
            {fieldObject.helpLink && <a href={fieldObject.helpLink} target="blank" title="Get help" className="help-link"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-question-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
</svg></a>}
            {(() => {
                switch(inputType) {
                    case 'textarea':
                        return <FormInputComponentDecorator error={error} fieldObject={fieldObject}>
                            <textarea
                                className={'form-control ' + (error[uniqueName] ? 'is-invalid' : '')}
                                name={uniqueName}
                                onChange={controller.handleChange}
                                onBlur={controller.validateInput} {...opts}
                            >{input[uniqueName]}</textarea>
                        </FormInputComponentDecorator>
                    case 'file':
                        if(fieldObject.accept) opts['accept'] = fieldObject.accept;
                        return <FileInputComponent
                            error={error}
                            controller={controller}
                            fieldObject={fieldObject} {...opts}
                        />
                    case 'checkbox':
                         return <FormInputComponentDecorator error={error} fieldObject={fieldObject}>
                                <input
                                    type={inputType}
                                    className="form-check-input"
                                    name={uniqueName}
                                    value={input[uniqueName]}
                                    onChange={controller.handleChange}
                                    onBlur={controller.validateInput} {...opts}
                                />
                                <label class="form-check-label" for="{uniqueName}">{label}</label>
                            </FormInputComponentDecorator>
                    default:
                        return <FormInputComponentDecorator error={error} fieldObject={fieldObject}>
                            {!fieldObject.isReadOnly &&
                                <input
                                type={inputType}
                                className={'form-control ' + (error[uniqueName] ? 'is-invalid' : '')}
                                name={uniqueName}
                                value={input[uniqueName]}
                                onChange={controller.handleChange}
                                onBlur={controller.validateInput} {...opts}
                            />
                            }

                        </FormInputComponentDecorator>
                }
            })()}
        </div>
    );
}